module.exports = __webpack_public_path__ + "static/media/marc.8880a65c.jpg";